export const GAM_ACTIVE = 'active';
export const GAM_ACTIVATED = 'activated';
export const GAM_DEACTIVATED = 'inactive';
